module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "result"
  }, [_c('div', {
    staticClass: "success theme-color"
  }, [_c('icon', {
    attrs: {
      "type": "success"
    }
  }), _vm._v(" "), _c('span', [_vm._v("提交成功")])], 1), _vm._v(" "), _vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "grey"
  }), _vm._v(" "), _vm._m(2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "tipresult"
  }, [_c('p', [_vm._v("您的投保申请已受理，我们会在人工审核完成后扣款")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "tipmain"
  }, [_c('div', {
    staticClass: "tiptop"
  }, [_c('p', [_vm._v("您可以关注悟空保微信号iwukongbao，使用投保人手机号登录，点击底部“我的-个人中心-我的订单“查看订单详情")])]), _vm._v(" "), _c('div', {
    staticClass: "qrcode"
  }, [_c('div', {
    staticClass: "qrcode-inner"
  }, [_c('img', {
    attrs: {
      "src": "static/common/images/wkb_wx.png"
    }
  }), _vm._v(" "), _c('p', [_vm._v("关注悟空保公众号，查看订单详情")])])]), _vm._v(" "), _c('div', {
    staticClass: "payresultgrey"
  }, [_vm._v("\n      如有疑问可以拨打客服电话"), _c('br'), _c('a', {
    attrs: {
      "id": "tel-ask-about",
      "href": "tel:400-661-2992"
    }
  }, [_vm._v("400-661-2992")]), _vm._v("咨询\n    ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "tipbot"
  }, [_c('p', {
    staticClass: "safecontent"
  }, [_vm._v("投保流程")]), _vm._v(" "), _c('p', [_c('span', [_vm._v("1")]), _vm._v("提交申请：客户提交投保和扣款申请")]), _vm._v(" "), _c('p', [_c('span', [_vm._v("2")]), _vm._v("人工核保：保险公司审核客户投保信息、健康问卷信息")]), _vm._v(" "), _c('p', {
    staticClass: "lastone"
  }, [_c('span', [_vm._v("3")]), _vm._v("投保成功：扣款并生成保单，客户投保成功")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-79cc8cce","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vux-loader/src/before-template-compiler-loader.js!./~/vux-loader/src/template-loader.js!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Resultfit.vue
// module id = 683
// module chunks = 1